module.exports = __webpack_public_path__ + "img/IMG_9478-1200w.9cabb4c9.jpg";